import { regHasIntegerBlank, regNumber } from '../../utils/reg-patterns';
const inputTypeLabel = {
    telePhone: '固定电话',
    mobilePhone: '手机号码',
    creditCard: '信用卡号',
    debitCard: '借记卡号',
    number: '普通数字',
};
export const checkValid = ({ inputType, text }) => {
    const regPattern = inputType === 'number' ? regNumber : regHasIntegerBlank;
    if (!text ||
        (inputType === 'number' && text.endsWith('.')) ||
        regPattern.test(text)) {
        return true;
    }
    return false;
};
export const chooseRule = ({ inputType, leftText, maxLength }) => {
    const type = inputType ? inputType : 'number';
    const obj = {
        leftText: leftText || inputTypeLabel[inputType],
        maxLength: 0,
        ruleArr: [],
    };
    if (type === 'creditCard') {
        obj.ruleArr = [4, 8, 12];
        obj.maxLength = 27;
    }
    else if (type === 'debitCard') {
        obj.ruleArr = [4, 8, 12, 16];
        obj.maxLength = 23;
    }
    else if (type === 'mobilePhone') {
        obj.ruleArr = [3, 7];
        obj.maxLength = 13;
    }
    else if (type === 'telePhone') {
        obj.ruleArr = [3, 7];
        obj.maxLength = 14;
    }
    else {
        obj.ruleArr = [];
        obj.maxLength = 100;
    }
    obj.maxLength = maxLength ? maxLength + obj.ruleArr.length : obj.maxLength;
    return obj;
};
export const changeRule = ({ inputType, text }, ruleObj) => {
    let { ruleArr } = ruleObj;
    if (inputType === 'telePhone') {
        if (text[1] >= 3) {
            ruleArr = [4, 8];
        }
    }
    let ruleIndex = 0;
    let newText = '';
    if (text) {
        text = text.replace(/\s+/g, '');
        for (let i = 0; i < text.length; i++) {
            if (i % ruleArr[ruleIndex] === 0 && i !== 0) {
                ruleIndex++;
                newText += ` ${text[i]}`;
            }
            else {
                newText += text[i];
            }
        }
    }
    return newText;
};
